export default "/images/vendor/flag-icons/flags/4x3/my.svg?372223fb108f4360e86a937523a7e317";